module.exports = __webpack_public_path__ + "static/media/car_not_filled.50a1731c.svg";